import React from 'react';
import './ExperienceGallery.scss';
import CardWork from '../../Components/Mersa/CardWork/CardWork';
import ContactUs from '../../Components/Mersa/ContactUs/ContactUs';
import { dataListViw } from '../../Data/Data';
import { Helmet } from 'react-helmet';
import { getHomeList, getProjects } from '../../Network/home';
import { useQuery } from '@tanstack/react-query';
const ExperienceGallery = ({ t }) => {
  // const data = dataListViw(t);
  const { data: dataProjects, isLoading } = useQuery({
    queryKey: ['getProjects'],
    queryFn: () => getProjects(),
  });
  return (
    <div className="experience-gallery">
      <Helmet>
        <title>Projects - Merse</title>
      </Helmet>
      <div className="section-our-work-experience">
        <h2 className="title-our-work">{t.OurWork}</h2>
        <CardWork
          t={t}
          data={dataProjects?.data?.projects}
          isLoading={isLoading}
        />
      </div>
      <ContactUs t={t} />
    </div>
  );
};

export default ExperienceGallery;
